var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[(_vm.progress == 100)?_c('p',[_vm._v("لطفا چند لحظه منتظر بمانید ...")]):_c('p',[_vm._v(" در حال بارگذاری: "),_c('strong',[_vm._v(_vm._s(_vm.progress + "%"))])])])}
var staticRenderFns = []

export { render, staticRenderFns }